import { Expose, Transform } from "class-transformer";

export class CrmCompanyDto {
  @Expose()
  @Transform(({ value, obj }) => value ?? obj["accountnumber"])
  accountNumber!: string;

  @Expose()
  name!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["speed1_name2"])
  additionalName2!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["speed1_name3"])
  additionalName3!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["speed1_name4"])
  additionalName4!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["address1_line1"])
  streetAndHouseNumber!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["address1_city"])
  city!: string;

  @Expose()
  @Transform(({ value, obj }) => value ?? obj["address1_postalcode"])
  postalCode!: string;
}
